import MidiEffect from './MidiEffect.js';
import MidiTrigger from './MidiTrigger.js';
import {AbstractParameter} from 'parameters/AbstractParameter.js';
import Tone from 'tone';

class HarmonyEffect extends MidiEffect {
    constructor(sequencerEngine) {
        super('Harmony', sequencerEngine);

        // parameters for the arpeggiator
        this.pitchParameter = new AbstractParameter(
            'pitch', this, (o, x) => x,
            {
               min: -32,
               documentation: "Gets added to the transpose of the trigger to be harmonized with",
               max: 32,
               unit: '',
               defaultValue: 5
            });
        this.registerParameter(this.pitchParameter);

        // parameters for the arpeggiator
        this.timingOffsetParameter = new AbstractParameter(
            'timingOffset', this, (o, x) => x,
           {
               min: 0,
               documentation: "The harmonizing trigger gets delayed by this amount of time (measured in 1/32th notes)",
               max: 4,
               unit: '',
               defaultValue: 0
            });
        this.registerParameter(this.timingOffsetParameter);

        // parameters for the arpeggiator
        this.velocityParameter = new AbstractParameter(
            'velocity', this, (o, x) => x,
           {
                min: 0,
               documentation: "The velocity of the harmonizing trigger",
                max: 1,
                unit: '',
                defaultValue: 1
            });
        this.registerParameter(this.velocityParameter);

        // parameters for the arpeggiator
        this.probabilityParameter = new AbstractParameter(
            'probability', this, (o, x) => x,
            {
                min: 0,
                documentation: "The probability that a harmonizing trigger will be created. This gets calculated for every trigger.",
                max: 100,
                unit: '',
                defaultValue: 100
            });
        this.registerParameter(this.probabilityParameter);
    }

    getVisualizedParameters() {
        return [this.pitchParameter];
    }

    getText() {
        let pitch = Math.round(100*this.pitch)/100;
        if (pitch >= 0) {
            return "+" + pitch;
        }
        return pitch;
    }

    get documentation() {
        return "Harmonizes by adding an additional trigger offsetted by pitch, for every trigger.";
    }

    get pitch() {
        return this.pitchParameter.get();
    }

    get velocity() {
        return this.velocityParameter.get();
    }

    get timingOffset() {
        return this.timingOffsetParameter.get();
    }

    get probability() {
        return this.probabilityParameter.get();
    }

    output() {
        let out = [];
        for (let i in this.triggers) {
            let trigger = this.triggers[i];
            out.push(trigger);

            if (this.probability / 100.0 >= Math.random()) {
                let stepData = trigger.stepData.getCopy(true, false, true, true, false);
                stepData.transpose += this.pitch;
                stepData.velocity = this.velocity;
                let time = trigger.time +
                    (this.timingOffset * new Tone.Time('32n').toMilliseconds()) / 1000.0;
                out.push(new MidiTrigger(stepData, time, trigger.stepNumber));
            }
        }

        return out;
    }

    getCopy(track, ignoreId=true) {
        let warpEffect = new HarmonyEffect(track);
        warpEffect.fromJson(this.getJson(), ignoreId);
        return warpEffect;
    }
}

export default HarmonyEffect;
